<div class="toast-progress-bar"></div>

<div class="circle-wrapper">
    <div class="outline-outer">
        <div class="outline-inner">
            <div class="icon-glow-ring"></div>
            <floori-icon [name]="iconName()" class="type-icon"></floori-icon>
        </div>
    </div>
</div>

<div class="label-wrapper">
    <span class="label-text">{{ isTextTranslated() ? label : (label | flTranslate) }}</span>
    @if (actionButton) {
    <a class="action-link" (click)="onActionButtonClick()">
        {{ actionButton.label | flTranslate }}
    </a>
    }
</div>

@if (showCloseButton) {
<button floori-icon-button class="small no-border close-btn" [floori-dialog-close]="true" aria-label="Close notification">
    <floori-icon name="fl_close"></floori-icon>
</button>
}

